import styled from '@xstyled/styled-components';
import TickMark from '~/assets/icons/tick-mark.svg';

export const TickMarkIcon = styled(TickMark)`
  max-width: 33px;
  max-height: 33px;
  stroke: black;
  width: 33px;
  height: 25px;
`;
